import { ExperienceItem } from '@app/utils/types';
import { useKeywords } from '@app/hooks';
import { useMemo } from 'react';

function useExperiences({ eventData, experiencesData }: any): {
  experiencesContent: ExperienceItem[];
  keywords: string;
} {
  let foundExperienceData: any;

  if (eventData) {
    foundExperienceData = eventData?.homePage?.find(
      (el: any) => el.__typename === 'ComponentExperienceExperienceGroup'
    );
  } else {
    foundExperienceData = experiencesData;
  }

  const keywords = useKeywords(foundExperienceData?.experience?.keywords || []);

  const experiencesContent = useMemo(() => {
    const items = foundExperienceData?.experience?.experience_items || [];

    const itemsFiltered = items.filter(
      (item: any) => item.hidden !== true
    ) as ExperienceItem[];

    return itemsFiltered.sort(
      (a, b) =>
        a.order - b.order ||
        a.title.toLowerCase().localeCompare(b.title.toLowerCase())
    );
  }, [foundExperienceData]);

  return { experiencesContent, keywords };
}

export default useExperiences;
